import request from '@/untils/request.js'


//  角色列表
export function GetRoleList(data) {
  return request({
    url:  'GetRoleList',
    method: 'get',
    params: data
  })
}
//  绑定活动角色
export function BindRole(data) {
  return request({
    url:  'BindRole',
    method: 'get',
    params: data
  })
}
//  获取用户数量
export function GetTotalUserCount(data) {
  return request({
    url:  'GetTotalUserCount',
    method: 'get',
    params: data
  })
}
//  创建宗门
export function CreateFamily(data) {
  return request({
    url:  'CreateFamily',
    method: 'post',
    data
  })
}
//  创建宗门
export function GetBindRoleInfo(data) {
  return request({
    url:  'GetBindRoleInfo',
    method: 'get',
    params: data
  })
}
//  宗门列表
export function GetFamilyList(data) {
  return request({
    url:  'GetFamilyList',
    method: 'get',
    params: data
  })
}
//  加入宗门
export function JoinFamily(data) {
  return request({
    url:  'JoinFamily',
    method: 'get',
    params: data
  })
}

export function IsHasFamily(data) {
  return request({
    url:  'IsHasFamily',
    method: 'get',
    params: data
  })
}
